<template>
  <v-dialog :value="value"
            width="80vw"
            height="90vh"
            @input="closeDialog()"
  >
    <v-card>
      <v-card-title primary-title><h1>Ayuda</h1></v-card-title>
      <v-card-text style="height: calc(100vh - 236px); overflow-y: auto;">
        <ContextHelpContent
            v-if="value"
            :path="routeId"
            @change="helpHtml = formModel.contenidoAyuda = $event"
        />
        <HtmlInput v-if="editando" v-model="formModel.contenidoAyuda"></HtmlInput>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="puedeEditar && !editando" text @click="editando = true">Editar</v-btn>
        <v-btn
            color="primary"
            text
            @click="$emit('input', false)"
            v-if="!editando"
        >
          Cerrar
        </v-btn>
        <v-btn text :disabled="guardando" v-if="editando" @click="cancelEdit()">Cancelar</v-btn>
        <v-btn text :disabled="guardando" color="primary" v-if="editando" @click="guardarForm()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessage from "../utils/ErrorMessage";
import permisosMixin from "../../mixins/permisosMixin";
import {EDITAR_AYUDA_CONTEXTUAL} from "../../permisosConstants";
import HtmlInput from "../HtmlInput";
import saveRegistroMixin from "../../mixins/crud-mixins/saveRegistroMixin";
import ContextHelpContent from './ContextHelpContent';

export default {
  name: 'ContextHelp',
  components: { ContextHelpContent, HtmlInput, ErrorMessage},
  props: {
    value: {
      type: Boolean,
    },
    baseUrl: {
      default: () => 'ayuda',
    },
  },
  mixins: [permisosMixin, saveRegistroMixin, ],
  data: () => ({
    loading: false,
    error: false,
    helpHtml: null,
    errorMessage: 'No se pudo obtener el contenido',
    editando: false,
    formModel: {
      contenidoAyuda: null,
      path: null,
    },
  }),
  watch: {
    value(val) {
      if (val) {
        this.getHelp();
      }
    },
  },
  methods: {
    getFormModel() {
      const model = Object.assign({}, this.formModel);
      model['path'] = encodeURIComponent(this.path);
      return model;
    },
    closeDialog() {
      this.editando = false;
      this.$emit('input', false);
    },
    onFormSaved(obj) {
      if (obj && obj.id) {
        this.id = obj.id;
      }
      this.helpHtml = this.formModel.contenidoAyuda;
      this.editando = false;
    },
    cancelEdit() {
      this.formModel.contenidoAyuda = this.helpHtml;
      this.editando = false;
    },
  },
  computed: {
    routeId () {
      return encodeURI(this.$route.matched[this.$route.matched.length - 1].path);
    },
    puedeEditar() {
      return this.tienePermiso(EDITAR_AYUDA_CONTEXTUAL);
    },
  },
};
</script>

<style scoped>
</style>
